/**
 * 跨系统跳转 URL 构造器
 * 把当前语言作为 ?lang= 参数附加到 URL，让目标系统启动时自动应用。
 * 对接收方的 resolver：URL ?lang= 优先级高于 localStorage。
 */

import { i18n } from '@/i18n';

/**
 * 在 URL 上追加 ?lang=<currentLocale>。
 * 如果 URL 已有 ?lang= 参数会被覆盖；如果有其他 query 会保留。
 * 保留 URL 原始 hash（如 devsync 同步用的 #__devsync=）。
 */
export function withLang(url: string): string {
  try {
    const lang = i18n.locale || 'zh-CN';
    // 把 URL 拆成 base + query + hash
    let base = url;
    let hash = '';
    const hashIdx = url.indexOf('#');
    if (hashIdx >= 0) {
      base = url.slice(0, hashIdx);
      hash = url.slice(hashIdx);
    }
    const qIdx = base.indexOf('?');
    const path = qIdx >= 0 ? base.slice(0, qIdx) : base;
    const existingQs = qIdx >= 0 ? base.slice(qIdx + 1) : '';
    // 构建新 query
    const params = new URLSearchParams(existingQs);
    params.set('lang', lang);
    return path + '?' + params.toString() + hash;
  } catch {
    return url;
  }
}
